import { Component } from 'react';


class ResultsHeader extends Component {

    render() {
        return (
            <>
            <div>
                <h1>Survey Results</h1>
            </div>
            </>
        )
    }
}

export default ResultsHeader;